import React from 'react';
import { Link } from 'react-router-dom';

// import img2 from '../../../assets/img/video-bg/logo270320.png';
// import img3 from '../../../assets/img/video-bg/poster-3.jpg';

import img3 from '../../../assets/img/video-bg/poster-0.png';

function About(props) {
    return (
        <section className="about-section-three section-gap">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-md-10 order-2 order-lg-1">
                        <div className="about-text-three">
                            <div className="section-title left-border mb-40">
                                <span className="title-tag">About J.W. Oliver Jr.</span>
                                <h3 className="title">"Entrepreneur, Leader, Speaker, <br />Father, Husband, Loves Jesus"</h3>
                            </div>
                            <p className="mb-25">
                                J.W. Oliver is a visionary leader, entrepreneur, and philanthropist.
                                He was born in Evreux, France, and is the proud son of a USAF Veteran and an awesome mom.
                                He grew up in a poor family but was raised by a supportive and loving family that nurtured
                                him from the reality of their less than privileged circumstances.
                                JW is a strong Christ follower who was raised in the church.

                            </p>
                            <p>
                                An entrepreneur since age 12 selling “PopRocks” from his middle school locker,
                                he started his first business venture in 1984 and has not looked back since.
                                He has started up more than 20+ companies from dental imaging, an outsourcing
                                center in Africa, an international property management group, a collegiate
                                summer baseball team, and even a skateboard park. He has over 35 years in the
                                Dental/Digital Imaging Business and is currently the Managing Partner of ZimWorX,
                                an outsourcing center in Zimbabwe
                            </p>
                            <br />

                            {/* <ul className="about-list">
                                <li> <i className="far fa-check" /> Business &amp; Consulting Agency</li>
                                <li> <i className="far fa-check" /> Awards Winning Business Comapny</li>
                                <li> <i className="far fa-check" /> Business &amp; Consulting Agency</li>
                                <li> <i className="far fa-check" /> Awards Winning Business Comapny</li>
                            </ul> */}
                            <Link to="/about" className="main-btn main-btn-4">Learn More</Link>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-10 order-1 order-lg-2">
                        <div className="about-tile-gallery" >
                            <img style={{ maxWidth: "max-content" }} src={img3} alt="" className="image-one wow fadeInRight" data-wow-duration="1500ms" data-wow-delay="400ms" />
                            {/* <img src={img2} alt="" className="image-two wow fadeInRight" data-wow-duration="1500ms" data-wow-delay="600ms" /> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;